<template>
  <div :versionItem="versionItem">
    <div style="width: 838px;margin: auto;">
      <h3>{{ $t('myprojectsList.version.collapse .content.title') }}</h3>
      <p
        class="release"
      >Dropdown menus are positioned relative to both the element that generates them and the edges of the screen or browser. They can appear in front of, beside, above, or below the element that generates them.</p>
    </div>
    <div id="versionMore">
      <el-table
        :data="appList"
        :cell-style="cellStyle"
        :header-cell-style="headerStyle"
        style="width: 100%"
      >
        <el-table-column prop="newStatus" :label="$t('myprojectsList.version.table.header.status')">
          <template slot-scope="scope">
            <span
              :class=" scope.row.newStatus.style "
              class="statusAppListClass"
            >{{ $t(scope.row.newStatus.displayI18n) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="updatedAt" :label="$t('appAnalysis.echarts.table.header.date')" width="316px">
          <template slot-scope="scope">
            <p>{{ momentFunc(scope.row.updatedAt) }}</p>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
moment.locale('zh-cn')
export default {
    props: ['versionItem'],
    data () {
        return {
            tableData: [],
            appList: []
        }
    },
    mounted () {
        this.settingMapping()
    },
    methods: {
        settingMapping (data) {
            let keys = [
                {
                    key: 'newStatus',
                    val: 'draft'
                }
            ]
            this.appList = this.versionItem.history
            this.getMapping(this.versionItem.history, keys)
        },
        getMapping (data, keys) {
            keys.forEach((ele, ind) => {
                let clone = this._languageTransfer(
                    data.map(i => {
                        if (!i[ele['key']]) {
                            i[ele['key']] = ele['val']
                        }
                        return i[ele['key']]
                    })
                )
                this.appList = this.appList.map((item, index) => {
                    item[ele['key']] = clone[index]
                    return item
                })
            })
        },
        momentFunc (date) {
            return moment(date).format('YYYY 年 MM 月 DD 日 a h:mm:ss')
        },
        cellStyle ({ row, column, rowIndex, columnIndex }) {
            if (columnIndex === 1) {
                return `
                font-size: 14px;
                `
            } else {
                return `
                padding-left:23px!important;
                `
            }
        },
        headerStyle ({ row, column, rowIndex, columnIndex }) {
            if (columnIndex === 1) {
                let str = `color: #333333;letter-spacing: 0.8px;height:40px;box-sizing:border-box;padding: 0px;`
                return str
            } else {
                let str = `color: #333333;letter-spacing: 0.8px;height:40px;box-sizing:border-box;padding: 0px;padding-left:23px!important;`
                return str
            }
        }
    },
    watch: {
        versionItem () {
            this.settingMapping()
            return this.versionItem
        }
    }
}
</script>

<style scoped>
* {
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 0.8px;
    color: #333333;
    font-family: sans-serif;
    font-size: 12px;
    font-weight: 300;
}
h1,
h3,
p {
    margin: 0px;
}
h3 {
    width: 324px;
    height: 20px;
    font-size: 14px;
    font-weight: 500;
    margin-top: 20px;
}
#versionMore {
    margin-top: 20px;
}
.release {
    width: 873px;
    height: 40px;
    margin-top: 5px;
}
.statusAppListClass {
    display: inline-block !important;
    height: 25px;
    border-radius: 4px;
    background-color: rgba(51, 51, 51, 0.1);
    display: block;
    text-align: center;
    line-height: 25px;
    color: #333333;
    border: 1px solid rgba(51, 51, 51, 0.3);
    padding: 0px 5px;
}
.statusAppListSuccess {
    background-color: rgba(0, 181, 226, 0.1);
    border: 1px solid #00b5e2;
    color: #00b5e2;
}
.statusAppListFail {
    color: #ffc44f;
    border: 1px solid #ffc44f;
    background-color: rgba(255, 196, 79, 0.1);
}
</style>
<style>
#versionMore .el-table--fit {
    border-right: 0;
    border-radius: 8px;
    border-bottom: 0;
    border: 1px solid rgba(51, 51, 51, 0.2);
    border-bottom: none;
}
#versionMore .el-table .cell {
    padding: 0px;
}
#versionMore .el-table--enable-row-hover .el-table__body tr:hover > td {
    background-color: rgba(0, 224, 218, 0.05) !important;
}
#versionMore .el-table th > .cell {
    letter-spacing: 1px;
}
</style>
